import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCheck: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="shield-check, security, protection">
      <path
        d="M9.5 11.75L11 13.25L14.5 9.75M12 3L20 5.75V11.9123C20 16.8848 16 19 12 21.1579C8 19 4 16.8848 4 11.9123V5.75L12 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconShieldCheck;
